import { r as registerInstance, h, e as Host, g as getElement } from './index-6c727dca.js';
import './component-errors-b6f1109b.js';
import { k as klassList } from './utils-c16d9285.js';

const epiHeadingCss = ".epi-heading{font-size:clamp(1px, 1rem, 10px);line-height:1;margin:0}.epi-heading.m--appears-as-1{font-size:28px;line-height:1.2;font-weight:600}.epi-heading.m--appears-as-2{font-size:24px;line-height:1.16;font-weight:600}.epi-heading.m--appears-as-3{font-size:18px;line-height:1.3;font-weight:600}.epi-heading.m--appears-as-4{font-size:18px;line-height:1.5;font-weight:400}.epi-heading.m--appears-as-5{font-size:30px;line-height:1.2;font-weight:600;font-family:var(--fontStackAlt)}.epi-heading.m--color-primary{color:var(--brandPrimary)}.epi-heading.m--color-accent{color:var(--brandAccent)}.epi-heading.m--color-warn{color:var(--brandWarn)}.epi-heading.m--color-secondary{color:var(--brandSecondary)}.epi-heading.m--color-none{color:var(--richBlack)}.epi-heading.m--color-inherit{color:inherit}.epi-heading.m--no-margin{margin:0}";

const EpiHeading = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.klassName = `epi-heading`;
    /** The type of heading to be put in to the page */
    this.level = 1;
    /** The theme color of the heading text */
    this.color = null;
    /** The type of heading that should be visibly mimicked. This allows for proper semantics while allowing headings to appear stylistically as other types of headings */
    this.appearsAs = null;
    /** Whether or not there should be a margin underneath the heading */
    this.noMargin = false;
  }
  get headingClassList() {
    return [
      this._colorModifier,
      this._headingApperance,
      this.noMargin && `m--no-margin`,
    ];
  }
  get _colorModifier() {
    var _a;
    // return `${this.klassName}__text m--color-${this.color ?? `none`}`;
    return `m--color-${(_a = this.color) !== null && _a !== void 0 ? _a : `none`}`;
  }
  get _headingApperance() {
    return `m--appears-as-${this.appearsAs || this.level}`;
  }
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender () { }
  // componentDidRender () { }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  /**
   * The render() function should always be the last one in the class
  */
  render() {
    return (h(Host, { class: klassList(this.klassName, ...this.headingClassList), role: "heading", "aria-level": this.level }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
EpiHeading.style = epiHeadingCss;

export { EpiHeading as epi_heading };
